import { useState, useCallback, useMemo } from 'react';
import { message } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';

import RefereeSelector from './RefereeSelector';
import OrgSelector from './OrgSelector';

import request from '@/request';

export default function AddDataButton({ type = '', onSuccess = () => {} }) {
  const [loading, setLoading] = useState(false);
  const [drawerOpen, setDrawerOpen] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);

  const handleToggle = (item) => {
    setSelectedItems((prev) =>
      prev.some((i) => i.id === item.id)
        ? prev.filter((i) => i.id !== item.id)
        : [...prev, item]
    );
  };

  const api = useMemo(() => {
    if (type === 'referee') {
      return '/events/admin/referee/list';
    } else if (type === 'organization') {
      return '/events/admin/leader/list?isAllOrg=true';
    }
    return '';
  }, [type]);

  const handleConfirm = useCallback(async () => {
    setDrawerOpen(false);
    setLoading(true);

    try {
      const ids = selectedItems.map((item) => item.id);
      if (type === 'referee') {
        await request.post('/events/admin/org/referee/invite', {
          refereeIds: ids,
        });
      } else if (type === 'organization') {
        await request.post('/events/admin/select/leader', { leaderIds: ids });
      }
      setLoading(false);
      message.success('添加成功');
      setSelectedItems([]);
      onSuccess?.();
    } finally {
      setLoading(false);
    }
  }, [selectedItems, onSuccess, type]);

  return (
    <>
      <button
        onClick={() => setDrawerOpen(true)}
        disabled={loading}
        className={`inline-flex items-center gap-2 self-start px-4 py-2 text-sm font-semibold text-white bg-blue-600 rounded-lg hover:bg-blue-700 transition-all duration-200 ${
          loading ? 'opacity-50 cursor-not-allowed' : 'cursor-pointer'
        }`}
      >
        {loading ? (
          <LoadingOutlined />
        ) : (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="1.8"
            className="w-4 h-4"
          >
            <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
            <circle cx="9" cy="7" r="4" />
            <path d="M20 8v6" />
            <path d="M23 11h-6" />
          </svg>
        )}
        <span>从平台库选择</span>
      </button>
      {type === 'referee' && (
        <RefereeSelector
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          onConfirm={handleConfirm}
          name="裁判"
          selectedItems={selectedItems}
          onToggle={handleToggle}
          okText="添加"
          api={api}
        />
      )}
      {type === 'organization' && (
        <OrgSelector
          open={drawerOpen}
          onClose={() => setDrawerOpen(false)}
          onConfirm={handleConfirm}
          selectedItems={selectedItems}
          onToggle={handleToggle}
          okText="添加"
          api={api}
        />
      )}
    </>
  );
}
